import {z} from "zod"

export const DynamicParameterDefinition = <ValueType>(valueSchema: z.ZodType<ValueType>) => ({
    meta: {
        nodeClass: "DynamicParameter",
    },
    validation: {
        parameters: z.object({value: valueSchema}),
        returns: z.any(),
    },
})
